import { Button, IconButton, Stack, Typography } from '@mui/material';
import useModal from '../../hooks/useModal';
import useLayoutContext from '../../hooks/useLayoutContext';
import { Close } from '@mui/icons-material';
import { getColor } from '../../assets/theme';
import { UseDisclosureInterface } from '@hooks/useDisclosure';

const ComingSoon = ({
  disclosure,
}: {
  disclosure?: UseDisclosureInterface;
}) => {
  const { ModalWrapper } = useModal();
  const {
    isOpenComingSoon,
    openComingSoon,
    closeComingSoon,
    toggleComingSoon,
  } = useLayoutContext();
  const { primary, secondary } = getColor();

  return (
    <>
      <ModalWrapper
        modalDisclosure={
          disclosure || {
            isOpen: isOpenComingSoon,
            onOpen: openComingSoon,
            onClose: closeComingSoon,
            onToggle: toggleComingSoon,
          }
        }
      >
        <Stack sx={{ p: 2, width: { xs: '100%', sm: '430px' } }}>
          <Stack width='100%' alignItems='flex-end'>
            <IconButton onClick={disclosure?.onClose || closeComingSoon}>
              <Close />
            </IconButton>
          </Stack>
          <Stack alignItems='center' p={2} gap={2} pt={0} width='100%'>
            <Typography
              variant='h2'
              color={secondary || primary}
              fontWeight='bold'
            >
              Coming Soon
            </Typography>
            <Typography sx={{ textAlign: 'center' }}>
              We’re putting the final touches on this feature!
              <br /> Stay Tuned!
            </Typography>
            <Button
              variant='contained'
              onClick={disclosure?.onClose || closeComingSoon}
              sx={{ width: '160px' }}
            >
              Close
            </Button>
          </Stack>
        </Stack>
      </ModalWrapper>
    </>
  );
};

export default ComingSoon;
